module.exports = () => {
  return {
    placement: 'web',
    type: '',
    account: null,
    billing: [],
    giftcards: [],
    rewards: [],
    upsells: [],
    upsellImages: [],
    tipSelected: null,
    applyDefaultTip: true,
    guestUser: null,
    showConfirmLocationPopUp: false
  }
}
